<template>
  <nav class="container">
    <div class="logo">
      <img src="@/assets/logo.png" alt="" />
      <span>{{ appName }}</span>
    </div>
    <div
      class="links"
      v-if="showSideBar"
      :class="{ 'animated fadeInRight': showSideBar }"
    >
      <router-link tag="li" to="/" exact>
        <a>Home</a>
      </router-link>
      <!-- <router-link tag="li" to="/about">
          <a>About</a>
        </router-link> -->
      <router-link tag="li" to="/pricing">
        <a>Pricing</a>
      </router-link>
      <router-link tag="li" to="/blog">
        <a>Blog</a>
      </router-link>
      <router-link tag="li" to="/contact">
        <a>Contact</a>
      </router-link>

      <router-link tag="li" to="/Login" class="active" v-if="user == null">
        <a>Login</a>
      </router-link>

      <router-link tag="li" to="/dashboard" v-if="user != null">
        <a>Dashboard</a>
      </router-link>
      <li v-if="user != null">
        <a href="#logout" @click="logout">Logout</a>
      </li>

      <div class="close" role="button" @click="showSideBar = false">
        <span>&times;</span>
      </div>
    </div>
    <div class="menu" @click="showSideBar = true" role="button">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </div>
  </nav>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Nav",

  computed: {
    appName() {
      return this.$store.state.appName;
    },
    user() {
      return this.$store.state.auth.user || null;
    }
  },

  data() {
    return {
      showSideBar: false
    };
  },

  created() {
    // console.log(this.$data.$screenSize);
    if (this.$data.$screenSize.width >= 991) {
      this.showSideBar = true;
    }
  },

  methods: mapActions({ logout: "auth/logout" })
};
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  flex: 0 1 auto;
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #0c1461;

  .logo {
    flex: 2;
    display: flex;
    align-items: center;

    span {
      margin-left: 10px;
    }
  }

  .links {
    flex: 10;
    text-align: right;
    justify-content: stretch;

    .close {
      display: none;
      cursor: pointer;
    }

    li {
      display: inline-block;
      margin: 5px;
      color: white;
      background-color: #9a3b82;
      list-style: none;

      &:hover,
      &.active {
        background-color: #fe5244;
        font-weight: bold;
      }

      a {
        padding: 15px;
        text-decoration: none;
        display: block;
        color: inherit;

        &:hover {
          font-weight: bold;
        }
      }
    }
  }

  .menu {
    display: none;
    cursor: pointer;
  }
}

@media (max-width: 991px) {
  nav {
    display: flex;
    height: 30px;
    border-bottom: 1px solid #ffffff55;
    margin: 0px !important;

    .logo {
      align-items: center;

      span {
        margin-left: 15px;
      }
    }

    .menu {
      display: flex;
      flex-direction: column;
      height: 30px;
      width: 30px;

      .bar {
        flex: 1;
        border-radius: 3px;
        height: 3px;
        width: 30px;
        background-color: #ffffff;
        margin: 2px auto;
      }
    }

    .links {
      position: fixed;
      z-index: 10;
      top: 0;
      bottom: 0;
      right: 0;
      width: 250px;
      background-color: #ffffffee;
      text-align: center;
      padding: 50px 5px 5px;
      overflow-y: scroll;

      .close {
        display: inline-block;
        position: fixed;
        top: 5px;
        right: 12px;
        z-index: 10;
        font-size: 40px;
        font-weight: 900;
        color: #0c1461;
      }

      li {
        display: block;
        padding: 5px 0;
        border: 2px solid #0c1461;
        border-radius: 3px;
        margin-bottom: 0px;
        color: #0c1461;
        background-color: #ffffff;
        font-weight: normal;

        a {
          padding: 5px;
          font-size: 20px;
        }
      }
    }
  }
}
</style>
